export const deepEquals = (obj1: unknown, obj2: unknown): boolean => {
  if (obj1 === obj2) return true
  if (!obj1 || !obj2) return false

  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) return false

    return obj1.every((elem, index) => {
      return deepEquals(elem, obj2[index])
    })
  }

  if (typeof obj1 === 'object' && typeof obj2 === 'object') {
    if (Array.isArray(obj1) || Array.isArray(obj2)) return false

    const keys1 = Object.keys(obj1)
    const keys2 = Object.keys(obj2)

    if (keys1.length !== keys2.length || !keys1.every((key) => keys2.includes(key))) return false

    for (const key in obj1) {
      if (!deepEquals((obj1 as Record<string, unknown>)[key] as unknown, (obj2 as Record<string, unknown>)[key] as unknown)) {
        return false
      }
    }
    return true
  }
  return false
}
